import { observer } from "mobx-react-lite";
import type { ConditionsConfig_ConditionConfig } from "@smartsuite/automation-engine-api";
import { useRootStore } from "../../../../stores/hooks";
import { ConditionsEditor } from "../TriggerSection/ConditionsForm/ConditionsEditor";
import type { BranchRef } from "../../../../stores/automation/branches.store";

export const BranchConditionsForm = observer<{ branchRef: BranchRef }>(
  ({ branchRef }) => {
    const store = useRootStore();
    const candidate = store.automations.candidate;
    const branches = candidate.branches;
    const branch = branches.findBranch(branchRef);
    const conditions =
      branch !== undefined && "conditions" in branch
        ? branch.conditions
        : undefined;
    const conditionFields = candidate.self.trigger.description.conditionFields;

    return (
      <div data-testid="branch-conditions">
        <ConditionsEditor
          conditions={conditions}
          conditionFields={conditionFields}
          candidate={candidate}
          integrations={store.integrations.list}
          action={undefined}
          leftSide="reference"
          branchRef={branchRef}
          excludeChangesFn
          showTriggerConditionErrors={false}
          showIncompleteError={candidate.isTriggerSubmitted}
          allowDelete
          isAllowAdd={
            (conditions?.group.length ?? 0) <
            store.featureFlags.limits.maxTriggerConditions
          }
          onAdd={() => branches.addCondition(branchRef)}
          onChange={(
            condition: ConditionsConfig_ConditionConfig,
            index: number,
          ) => branches.updateCondition(branchRef, condition, index)}
          onDelete={(index: number) =>
            branches.deleteCondition(branchRef, index)
          }
          onSwitchOperator={() => branches.switchConditionOperator(branchRef)}
        />
      </div>
    );
  },
);
BranchConditionsForm.displayName = "BranchConditionsForm";
